import {ReadyProvider} from '../../../application/providers/readyProvider';
import {ContentLoader} from './contentLoader';

ReadyProvider.executeOnReady(() => {
    document.querySelector('[data-action="search-brand"]').addEventListener('input', (event) => {
        ContentLoader.loadContent(event.currentTarget.value);
    });

    document.querySelector('[data-action="drop-search"]').addEventListener('click', (event) => {
        event.preventDefault();
        let filter = document.querySelector('[data-action="search-brand"]');

        if (filter.value === '') {
            return;
        }

        filter.value = '';
        ContentLoader.loadContent(null);
    });
});
